import { InjectionToken } from '@angular/core';
import { AnswerRow } from '../domain/types';

/** Synchronous crash-cache for in-progress answer work. */
export interface AnswerDraftCache {
  read(paperToProjectId: string): AnswerRow[] | null;
  write(paperToProjectId: string, rows: AnswerRow[]): void;
  clear(paperToProjectId: string): void;
}

export const ANSWER_DRAFT_CACHE = new InjectionToken<AnswerDraftCache>('ANSWER_DRAFT_CACHE');
